import { render, staticRenderFns } from "./loginAccount.vue?vue&type=template&id=676bf5a5&scoped=true"
import script from "./loginAccount.vue?vue&type=script&lang=js"
export * from "./loginAccount.vue?vue&type=script&lang=js"
import style0 from "./loginAccount.vue?vue&type=style&index=0&id=676bf5a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676bf5a5",
  null
  
)

export default component.exports